@if (message.id) {
  <div class="task-view-comments-form__edit-content">
    <div class="task-view-comments-form__edit-content-left">
      <div class="task-view-comments-form__edit-content-close" (click)="onCloseEdit()">
        <i class="icon-close"></i>
      </div>
    </div>
    <div class="task-view-comments-form__edit-content-right">
      <div class="task-view-comments-form__edit-content-header">Редактировать сообщение</div>
      <div class="task-view-comments-form__edit-content-text">
        {{ messageOrigin.message }}
      </div>
    </div>
  </div>
}
<div class="task-view-comments-form__row">
  <textarea
    autosize
    rows="1"
    class="task-view-comments-form__comment-form"
    placeholder="Написать сообщение…"
    autofocus
    (keydown.enter)="onSubmit($event)"
    (paste)="onPasteFile($event)"
    [formControl]="messageControl"
  >
  </textarea>
  <div class="task-view-comments-form__controls">
    <div class="task-view-comments-form__icons">
      <!--<span class="task-view-comments-form__icon"><i class="icon-smile"></i></span>-->
      <span class="task-view-comments-form__icon" (click)="onOpenTimeForm()"><i class="icon-time"></i></span>
      <span class="task-view-comments-form__icon task-view-comments-form__icon_file"
        ><input
          #inputUploadFiles
          type="file"
          [multiple]="true"
          (change)="onFileUpload($event)"
          accept=".pdf,.doc,.docx,.zip,.rar,.png,.jpeg,.jpg,.txt,.csv,.xls,.xlsx,.ppt,.pptx,.webp,.gif,.svg,.mp4,.mp3,.avi,.mov,.json,.xml,.7z,.tar,.gz" /><i
          class="icon-add"
        ></i
      ></span>
      <span class="task-view-comments-form__icon task-view-comments-form__icon_active" (click)="onSubmit($event)"
        ><i class="icon-send"></i
      ></span>
    </div>
    @if (isOpenTimeForm) {
      <app-task-view-comments-time
        (clickOutside)="onCloseTimeForm()"
        [delayClickOutsideInit]="true"
        (save)="onSetTime($event)"
        class="task-view-comments-form__time-popup"
      >
      </app-task-view-comments-time>
    }

    <!-- <span class="task-view-comments-form__info">Enter<br>для отправки</span> -->
  </div>
</div>

@if (message.files.length || files.length) {
  <div class="task-view-comments-form__files">
    <div class="task-view-comments-form__files-images">
      @for (image of message.files; track image.id) {
        @if (image.isImage) {
          <ux-preview-image
            [image]="image"
            class="task-view-comments-form__file-item"
            (deleteImage)="onDeleteFile($event)"
          >
          </ux-preview-image>
        }
      }
      @for (image of files; track image) {
        <ux-upload-image
          [image]="image"
          (onDelete)="onStopUploadAndDeleteFile(image)"
          class="task-view-comments-form__file-item"
        >
        </ux-upload-image>
      }
    </div>
    <div class="task-view-comments-form__files-file">
      @for (file of message.files; track file) {
        @if (!file.isImage) {
          <ux-preview-file [file]="file" (deleteFile)="onDeleteFile($event)"></ux-preview-file>
        }
      }
    </div>
  </div>
}
@if (message.time) {
  <app-task-view-comment-form-time [time]="message.time" (clear)="onClearTime()" class="task-view-comments-form__time">
  </app-task-view-comment-form-time>
}
